import { useState } from "react";

import ButtonSpinner from "../../../components/controls/ButtonSpinner";
import DollarInputText from "../../../components/controls/inputs/DollarInputText";

export default function AdjustInvPriceModal(props) {
  const { onAdjustPrice, setEmptyModelOpen } = props;

  const [amount, setAmount] = useState(0);
  const [error, setError] = useState(null);
  const [saving, setSaving] = useState(false);

  const submitAdjustment = async (event) => {
    event.preventDefault();
    if (saving) return;
    if (!Number.isFinite(Number(amount)) || Number(amount) <= 0) {
      setError("Amount must be over 0");
      return;
    }

    setError(null);
    setSaving(true);
    try {
      const result = await onAdjustPrice(amount);
      if (!result?.success) {
        setError(
          result?.data?.errors?.items?.[0] ||
            result?.data?.errors?.cost?.[0] ||
            result?.data?.message ||
            "Could not adjust the price. Please try again."
        );
      }
    } catch {
      setError("Could not adjust the price. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <form onSubmit={submitAdjustment}>
      <div>
        <div className="mt-3 text-start sm:mt-5">
          <p
            className="text-center text-base font-normal leading-6 text-gray-800 family-didact"
          >
            Adjust cost
          </p>
          <div className="mt-2 space-y-4 gap-4 text-center">
            <DollarInputText
              label="Unit Cost"
              name="unit_cost"
              onChange={(e) => {
                setAmount(e.target.value);
              }}
              value={amount}
              labelOn={true}
              inputId="unit_cost"
              disabled={saving}
            />
            {error && <p role="alert" className="font-medium text-red-500">{error}</p>}
          </div>
        </div>
      </div>
      <div className="mt-5 sm:mt-6 flex items-center justify-center gap-3">
        <button
          type="button"
          disabled={saving}
          className="inline-flex w-fit justify-center rounded-md bg-white px-3 py-2 text-sm font-light family-didact text-gray-900 shadow-sm hover:bg-gray-50 shadow-sm ring-1 ring-inset ring-gray-300"
          onClick={() =>
            setEmptyModelOpen({ childComponent: null, open: false })
          }
        >
          Cancel
        </button>
        <button
          type="submit"
          disabled={saving}
          className="rounded-md bg-main-purple px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        >
          <ButtonSpinner spin={saving} text="Adjust price" />
        </button>
      </div>
    </form>
  );
}
